import LegalPage from "@/components/site/LegalPage";

const sections = [
  {
    n: "1.",
    title: "Uploading Photos",
    body: (
      <>
        <p className="mb-3">
          Users and campsite owners may upload photographs, logos, campsite
          images, event images, and other visual content (&ldquo;Content&rdquo;)
          to My Adventure Passport.
        </p>
        <p className="mb-3">By uploading Content, you confirm that:</p>
        <ul className="list-disc pl-6 space-y-1 mb-3">
          <li>You own the Content; or</li>
          <li>
            You have obtained permission from the copyright owner to use and
            upload the Content; or
          </li>
          <li>
            The Content is licensed or otherwise legally permitted for such
            use.
          </li>
        </ul>
        <p>
          Content found on Facebook, Instagram, Google, websites, or other
          online platforms should not be uploaded solely because it is publicly
          accessible.
        </p>
      </>
    ),
  },
  {
    n: "2.",
    title: "Campsite Owner Content",
    body: (
      <>
        <p className="mb-3">
          Campsite owners may upload photographs, campsite logos, promotional
          materials, facilities information, and other content to their
          campsite profile.
        </p>
        <p className="mb-3">
          By uploading such Content, the campsite owner grants My Adventure
          Passport permission to display, reproduce, resize, crop, format, and
          use the Content within the My Adventure Passport platform for
          purposes related to:
        </p>
        <ul className="list-disc pl-6 space-y-1 mb-3">
          <li>Displaying and promoting the campsite;</li>
          <li>Campsite discovery and search;</li>
          <li>Adventure Passport features;</li>
          <li>Challenges and activities;</li>
          <li>
            MyAP social-media promotion of the campsite or platform; and
          </li>
          <li>Other MyAP promotional materials relating to the campsite.</li>
        </ul>
        <p>Ownership of the original Content remains with the respective owner.</p>
      </>
    ),
  },
  {
    n: "3.",
    title: "Unverified Campsites",
    body: (
      <>
        <p className="mb-3">
          Some campsites may initially appear as UNVERIFIED because they have
          been suggested by MyAP users or added to assist users in recording
          their adventures.
        </p>
        <p className="mb-3">
          MyAP may use generic campsite imagery or MyAP-designed placeholder
          images for these listings.
        </p>
        <p>
          A campsite owner may claim their campsite profile and provide
          official photographs, logos, information, and other authorised
          Content.
        </p>
      </>
    ),
  },
  {
    n: "4.",
    title: "User-Uploaded Photos",
    body: (
      <>
        <p className="mb-3">
          Users must ensure that photographs they upload do not:
        </p>
        <ul className="list-disc pl-6 space-y-1 mb-3">
          <li>
            Violate another person&rsquo;s copyright or intellectual property
            rights;
          </li>
          <li>
            Contain unlawful, offensive, obscene, discriminatory, or harmful
            material;
          </li>
          <li>Infringe another person&rsquo;s privacy;</li>
          <li>
            Misrepresent a campsite, event, organisation, or individual; or
          </li>
          <li>
            Contain content that the user does not have permission to share.
          </li>
        </ul>
        <p>MyAP reserves the right to remove Content that violates this policy.</p>
      </>
    ),
  },
  {
    n: "5.",
    title: "People Appearing in Photos",
    body: (
      <>
        <p className="mb-3">
          Users and campsite owners should obtain appropriate permission before
          uploading photographs in which individuals are clearly identifiable,
          particularly where the photograph is being used for promotional or
          commercial purposes.
        </p>
        <p>
          Extra care should be taken with photographs containing children.
        </p>
      </>
    ),
  },
  {
    n: "6.",
    title: "Copyright or Removal Requests",
    body: (
      <>
        <p className="mb-3">
          If you believe a photograph, logo, or other Content displayed on My
          Adventure Passport belongs to you and has been used without
          permission, you may submit a removal request to My Adventure
          Passport.
        </p>
        <p className="mb-3">
          Please provide sufficient information to identify the Content and
          explain your ownership or rights in relation to it.
        </p>
        <p>
          MyAP will review reasonable requests and may remove or restrict the
          Content while the matter is being investigated.
        </p>
      </>
    ),
  },
  {
    n: "7.",
    title: "Removal and Moderation",
    body: (
      <>
        <p className="mb-3">
          My Adventure Passport reserves the right to reject, hide, restrict,
          or remove Content that violates this policy, applicable law,
          third-party rights, or MyAP community standards.
        </p>
        <p>
          Repeated violations may result in restrictions or suspension of the
          relevant account.
        </p>
      </>
    ),
  },
];

export default function PhotoContentPolicy() {
  return (
    <LegalPage
      eyebrow="Photo & Content Policy"
      title="Photo & Content Policy"
    >
      <p className="mb-4 font-semibold" style={{ color: "var(--on-surface-muted)" }}>
        Last Updated: September 2026
      </p>
      <p className="mb-8">
        My Adventure Passport (&ldquo;MyAP&rdquo;) respects the intellectual
        property rights and privacy of campsite owners, users, photographers,
        and other content creators.
      </p>

      {sections.map((s) => (
        <div key={s.n} className="mb-8">
          <h2 className="text-xl md:text-2xl font-extrabold mb-3" style={{ color: "var(--on-surface)" }}>
            <span style={{ color: "var(--premium)" }}>{s.n}</span> &nbsp; {s.title}
          </h2>
          <div style={{ color: "var(--on-surface)" }}>{s.body}</div>
        </div>
      ))}
    </LegalPage>
  );
}
